import { render, staticRenderFns } from "./DashboardSetting.vue?vue&type=template&id=f20e7814&"
import script from "./DashboardSetting.vue?vue&type=script&lang=js&"
export * from "./DashboardSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports